import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      cartao: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: '"Nunito", sans-serif',
        padding: theme.spacing(1),
      },
      label: {
        flex: 'auto',
        fontWeight: 700,
        fontSize: 15,
        textAlign: 'left',
        fontFamily: '"Nunito", sans-serif',
        color: sicrediColor.secondarySicrediDarker,
      },
      value: {
        fontSize: 16,
        textAlign: 'right',
        fontWeight: 400,
        color: sicrediColor.secondarySicrediDarker,
      },
      syncLabel: {
        fontWeight: 'bold',
      },
    }),
  { name: 'RelatorioTotais' }
);
